export default "__VITE_ASSET__C7ZpBHq4__"